import { useCallback } from 'react';

import type { AnyObject } from '../../../../../types';
import { bridge } from '../../../../../utils';
import { useAtomicScreen } from '../../../context/AtomicScreenContext';

export const useLogClickOutfitCarousel = (logging: AnyObject) => {
  const screen = useAtomicScreen();

  const logClickContent = useCallback(
    (itemLogging: AnyObject) => {
      bridge.logAnalyticsEvent({
        name: 'CLICK_CONTENT',
        analytics: {
          ...logging?.analytics,
          ...itemLogging?.analytics,
          ...(screen != null && { SCREEN: screen }),
        },
        ably_only_log: {
          ...logging?.ably_only_log,
          ...itemLogging?.ably_only_log,
        },
      });
    },
    [logging, screen],
  );

  const logClickGoods = useCallback(
    (itemLogging: AnyObject) => {
      bridge.logAnalyticsEvent({
        name: 'CLICK_GOODS',
        analytics: {
          ...logging?.analytics,
          ...itemLogging?.analytics,
          ...(screen != null && { SCREEN: screen }),
        },
        ably_only_log: {
          ...logging?.ably_only_log,
          ...itemLogging?.ably_only_log,
        },
      });
    },
    [logging, screen],
  );

  return { logClickContent, logClickGoods };
};
